import { useEffect } from 'react'
import { bootHold, bootShowing } from '../lib/boot'
import { Topo } from './Topo'
import type { CSSProperties } from 'react'

/* Every icon lives in one inline sprite (src/assets/sprite.svg). */
export function Icon({ id, className, style, title }: { id: string; className?: string; style?: CSSProperties; title?: string }) {
  return (
    <svg className={className ?? 'ic'} style={style} aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title && <title>{title}</title>}
      <use href={'#' + id} />
    </svg>
  )
}

export function Coin({ size, className }: { size?: number; className?: string }) {
  return (
    <svg className={'coin' + (className ? ' ' + className : '')} style={size ? { width: size, height: size } : undefined} aria-hidden="true">
      <use href="#coin" />
    </svg>
  )
}

/* Waiting on something: the contour loader, or a small ring inside buttons and tight spots. */
export function Spinner({ size }: { size?: number }) {
  if (size != null && size < 30) return <span className="spin" style={{ width: size, height: size }} aria-label="Loading" role="status" />
  return <HoldingTopo size={size ?? 56} />
}
function HoldingTopo({ size }: { size: number }) {
  useEffect(() => (bootShowing() ? bootHold() : undefined), [])
  return <Topo size={size} />
}
